import type { DeployTypeCode } from './types';

/**
 * 全部出现在 `DeployTypeCode` 联合中的 code（含未注册插件）。
 * 判断「是否已挂 headless」请用 `isPluginDeployType`（读 registry），勿用本数组。
 */
export const DEPLOY_TYPE_CODES = [
  'VirtualMachine',
  'ContainerInstance',
  'ElasticBareMetal',
  'BareMetal',
  'SharedVolume',
  'ModelSubscription',
  'ModelInstance',
  'TrainingCluster',
  'AppInstance',
] as const satisfies readonly DeployTypeCode[];

/** 已注册交付插件（与 `plugins/register.ts` 对齐） */
export const REGISTERED_PLUGIN_DEPLOY_TYPE_CODES = [
  'VirtualMachine',
  'ContainerInstance',
  'ElasticBareMetal',
  'BareMetal',
  'ModelSubscription',
  'ModelInstance',
  'TrainingCluster',
  'AppInstance',
] as const satisfies readonly DeployTypeCode[];

/**
 * 类型存在但未 `registerDeployPlugin`。
 */
export const UNREGISTERED_DEPLOY_TYPE_CODES = ['SharedVolume'] as const satisfies readonly DeployTypeCode[];

const DEPLOY_TYPE_CODE_SET = new Set<string>(DEPLOY_TYPE_CODES);
const UNREGISTERED_DEPLOY_TYPE_CODE_SET = new Set<string>(UNREGISTERED_DEPLOY_TYPE_CODES);

export function isDeployTypeCode(code?: string): code is DeployTypeCode {
  return code != null && DEPLOY_TYPE_CODE_SET.has(code);
}

/** 是否为未注册占位类型（Legacy / 仅类型） */
export function isUnregisteredDeployType(code?: string): boolean {
  return code != null && UNREGISTERED_DEPLOY_TYPE_CODE_SET.has(code);
}
